export default "__VITE_ASSET__B4PzD$gJ__"